export default __webpack_public_path__ + "static/media/BIFI.87b64be4.png";